import { fromJS } from 'immutable';

import { INIT, INIT_SUCCESS, INIT_FAILED, SUBMIT, SUBMIT_SUCCESS, SUBMIT_FAILED } from './types';

export const initialState = fromJS({
  loading: false,
  error: null,
});

export default (state = initialState, action: { type: string; value?: boolean; error?: Error }) => {
  switch (action.type) {
    case INIT:
    case SUBMIT:
      return state.merge({ loading: true, error: null });

    case INIT_SUCCESS:
    case SUBMIT_SUCCESS:
      return state.set('loading', false);

    case INIT_FAILED:
    case SUBMIT_FAILED:
      return state.merge({ loading: false, error: action.error });

    default:
      return state;
  }
};
